import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { milestonesBackend } from './milestones.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { milestonesReducer } from './milestones.reducer';

// FIXME: remove that
backend.milestones = milestonesBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('milestones', milestonesReducer),
    /* DatastoreBackendModule.forFeature(
      'milestones',
      milestonesBackend,
    ),*/
  ],
})
export class DatastoreMilestonesModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/milestones/milestones.module.ts